import { DemandaUsoInsumo } from '../@types';
import aqilaApi from './aqila-api';

class DemandasUsoInsumo {
  private readonly endpoint = '/v1/demanda_uso_insumos';

  async list({
    propriedadeId,
    operacaoId,
    startDate,
    endDate,
  }: DemandasUsoInsumoListParams) {
    const { data } = await aqilaApi.get<DemandaUsoInsumo[]>(this.endpoint, {
      params: {
        data_final: endDate,
        data_inicial: startDate,
        aguardando_aprovacao: true,
        demanda_cronogramas: false,
        operacao: operacaoId,
        propriedade: propriedadeId,
      },
    });

    return data;
  }
}

type DemandasUsoInsumoListParams = {
  propriedadeId?: number;
  operacaoId?: number;
  startDate: string;
  endDate: string;
};

export default new DemandasUsoInsumo();
